export const maximumNumberOfFilesAllowed = 10;
export const maxFileSize = 1024 * 1024 * 1024;
export const forbiddenFileNameCharactersRegex = /[\\/:*?"<>|]/g;
